import { createI18n } from 'vue-i18n';

// 언어 파일 불러오기
import en from './locales/en.json';
import ko from './locales/ko.json';

const i18n = createI18n({
  legacy: false, // Composition API 사용 시 false 설정
  locale: 'ko', // 기본 언어
  fallbackLocale: 'ko', // 대체 언어
  messages: { ko, en }, // 언어 데이터 등록
});

export default i18n;
